import { render, staticRenderFns } from "./cardRecordDetail.vue?vue&type=template&id=1b5d3966&scoped=true&"
import script from "./cardRecordDetail.vue?vue&type=script&lang=js&"
export * from "./cardRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./cardRecordDetail.vue?vue&type=style&index=0&id=1b5d3966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d3966",
  null
  
)

export default component.exports